<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-select style="width: 100%;" filterable clearable  v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="点位名称" v-model="searchInfo.name">
					<template slot="prepend">点位名称</template>
				</el-input>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 400px;">
					<el-button type="primary" @click="searchSysConfig" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" icon="el-icon-s-promotion" @click="selfImportPoint">自动同步</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="deleteBySchool">删除校区开关点</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="pointSetList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="name" label="校区" width="100" align="center"></el-table-column>
			    <el-table-column prop="roomtype" label="房间类型"  width="100" align="center"></el-table-column>
				<el-table-column prop="roomname" label="房间名称"  width="100" align="center"></el-table-column>
				<el-table-column prop="devpropertyname" label="点位名称" width="200" align="center"></el-table-column>
				<el-table-column prop="enums" label="枚举值"  align="center"></el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="pointSetTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryRoomControl, queryAllOrg, syncRoomControl, deleteSchoolRoomControl } from '/static/apiUrl.js'
	export default {
		name : 'PointSetList',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '详情',
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
				},
				orgList : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				pointSetTotal : 0,
				pointSetList : [],
			}
		},
		mounted() {
			this.initData()
			this.queryPointSetting()
		},
		components: {
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryPointSetting()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryPointSetting()
			},
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			searchSysConfig(){
				this.param.page = 1
				this.pointSetList = []
				this.queryPointSetting()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.id = ''
				this.param.page = 1
				this.queryPointSetting()
			},
			deleteBySchool(){
				if(this.searchInfo.id == ''){
					this.$message({
						showClose: true,
						message: '请选择需要删除的校区。',
						type: 'warning'
					});
					return
				}
				let orgname = ''
				this.orgList.forEach((item) => {
					if(item.id == this.searchInfo.id){
						orgname = item.name
					}
				})
				this.$confirm('确定删除'+orgname+'下的一键开关点位吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteSchoolRoomControl({oid : this.searchInfo.id}).then(res => {
						if(0 == res.code){
							this.queryPointSetting()
							this.$message({
								showClose: true,
								message: "同步成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				})
			},
			queryPointSetting(){
				this.pointSetList = []
				queryRoomControl({
					oid : this.searchInfo.id,
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.pointSetTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							let orgname = ''
							this.orgList.forEach((item) => {
								if(item.id == set.orgid){
									orgname = item.name
								}
							})
							this.pointSetList.push({
								id: set.id,
								devpropertyid : set.devpropertyid,
								chosen : set.chosen,
								roomid : set.roomid,
								orgid : set.orgid,
								name : orgname,
								roomtype : set.roomtype,
								roomname : set.roomname,
								devpropertyname : set.devpropertyname,
								enums : set.enums
							})
						})
					}
				})
			},
			selfImportPoint(){
				if(this.searchInfo.id == ''){
					this.$message({
						showClose: true,
						message: '请选择需要同步的校区，请不要重复同步。',
						type: 'error'
					});
					return
				}
				let orgname = ''
				this.orgList.forEach((item) => {
					if(item.id == this.searchInfo.id){
						orgname = item.name
					}
				})
				this.$confirm('确定同步'+orgname+'点位吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					syncRoomControl({oid : this.searchInfo.id}).then(res => {
						if(0 == res.code){
							this.queryPointSetting()
							this.$message({
								showClose: true,
								message: "同步成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				})
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>